export default "__VITE_ASSET__Cy13HHvo__"